import React, { Component } from "react";
import Row from "../../containers/row";
import TitleBar from "../../titleBar";
import FourCol from "../../containers/fourCol";
import ThreeCol from "../../containers/threeCol";
import TwoCol from "../../containers/twoCol";
import Image from "../../image/image";
import Gutters from "../../config/gutters";
import gutter from "../../config/vars";

class ImageGrid extends Component {
  returnImages() {
    switch (this.props.gridSize) {
      case "0":
        return this.props.rowData.map((square, index) =>
          <div
            key={index}
            className={"image" + index + "" + this.props.gridSize}
          >
            <Image media={square.field_image} style={{ padding: gutter }} />
          </div>
        );
      case "1":
        return this.props.rowData.map((square, index) =>
          <TwoCol
            key={index}
            className={"image" + index + "" + this.props.gridSize}
          >
            <Image media={square.field_image} style={{ padding: gutter }} />
          </TwoCol>
        );
      case "2":
        return this.props.rowData.map((square, index) =>
          <ThreeCol
            key={index}
            className={"image" + index + "" + this.props.gridSize}
          >
            <Image media={square.field_image} style={{ padding: gutter }} />
          </ThreeCol>
        );
      case "3":
        return this.props.rowData.map((square, index) =>
          <FourCol
            key={index}
            className={"image" + index + "" + this.props.gridSize}
          >
            <Image media={square.field_image} style={{ padding: gutter }} />
          </FourCol>
        );
      default:
        return null;
    }
  }

  render() {
    const margin =
      Gutters.spacings[this.props.blockStyle.top] +
      "px 0px " +
      Gutters.spacings[this.props.blockStyle.btm] +
      "px 0px";
    const padding =
      Gutters.spacings[this.props.blockStyle.inner_top] +
      "px 0px " +
      Gutters.spacings[this.props.blockStyle.inner_btm] +
      "px 0px";
    const titleStyles = this.props.blockStyle.attributes
      .field_title_color_font[0];
    const titleClassName = this.props.blockStyle.name.replace(" ", "-");

    return (
      <Row
        className="ig"
        minHeight="588px"
        padding={padding}
        margin={margin}
        display="block"
        styles={{
          color: "#444",
          fontSize: "19px",
          lineHeight: " 19px",
          border: "0px dashed #cc00cc",
          gridGap: "0px"
        }}
      >
        {this.props.showTitle !== "0" && this.props.title !== "underfined"
          ? <TitleBar
              className={titleClassName}
              color={titleStyles.field_color_1}
              bgc={titleStyles.field_bgcolor_1}
              fontFamily={titleStyles.field_font_1.name}
              max="19"
              min="16"
              container="Left"
              tag="h2"
            >
              {this.props.title}
            </TitleBar>
          : null}
        {this.returnImages()}
      </Row>
    );
  }
}

export default ImageGrid;
